export default __webpack_public_path__ + "static/media/aira_3.48be8c38.PNG";